(function ($) {
  // cookies
  $.each($("#modal-cookies .collapse"), function (index, el) {
    $(el).on("hidden.bs.collapse", function (ev) {
      $(ev.target).prev("legend").removeClass("border-bottom");
    });
    $(el).on("shown.bs.collapse", function (ev) {
      $(ev.target).prev("legend").addClass("border-bottom");
    });
  });

  $("#modal-cookies legend input").on("change", function (e) {
    $(e.target).closest("fieldset").find("input[type=checkbox]").prop("checked", e.target.checked);
  });

  $(".collapse input[type=checkbox]").on("change", function (e) {
    var inputs = $(e.target).closest(".collapse").find("input[type=checkbox]");
    var res = {
      ok: 0,
      error: 0,
    };
    $.each(inputs, function (index, el) {
      el.checked ? res.ok++ : res.error++;
    });
    if (res.ok == inputs.length) {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", true);
    } else {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", false);
    }
  });

  $("#modal-cookies .btn-select-all").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]").prop("checked", true);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies .btn-just-essential").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]:not([disabled])").prop("checked", false);
    $(e.target).closest("form").submit();
    return false;
  });


  $("#modal-cookies form").on("submit", function (e) {
    var valid = ["cookiePolicy", "matomo", "adform", "google", "facebook"];
    var cookieData = {};
    var $form = $(e.target);
    var data = $form.serializeArray();

    $.each(valid, function (i, e) {
      var enable = data.findIndex(function (obj) {
        return obj.name === e;
      }) + 1 > 0;
      cookieData[e] = enable;
    });

    $.each(cookieData, function (key, enabled) {
      switch (key) {
        case "cookiePolicy":
          break;

        case "matomo":
          if (typeof _paq !== "undefined") {
            if (enabled) {
              _paq.push(["setCookieConsentGiven", 9480]);
            } else {
              _paq.push([
                function () {
                  if (!this.isUserOptedOut()) {
                    _paq.push(["forgetCookieConsentGiven"]);
                  }
                },
              ]);
            }
          }
          break;

        case "adform":
          if (enabled) {
            if (!Array.isArray(window._adftrack)) {
                initAdform();
              }
          }
          break;

        case "google":
          if (enabled) {
            if (typeof gtag === "undefined") {
                initGtag();
              }
          }
          break;

        case "facebook":
            if (enabled) {
              if (typeof fbq === "undefined") {
                initFBpx();
              }
          }
          break;
      }
    });
    BPM.COOKIESETTING = cookieData;
    createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    $("#modal-cookies").modal("hide");
    return false;
  });

  var checkCookie = function (name) {
    var nameCheck = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameCheck) == 0) return c.substring(nameCheck.length, c.length);
    }
    return null;
  };

  var createCookie = function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Strict";
  };

  var eraseCookie = function (name) {
    createCookie(name, "", -1);
  };

  var initAdform = function () {
    if (!ADFORM_ID || ADFORM_ID == 12345) {
      console.log('ADFORM_ID: ' + ADFORM_ID);
      return false;
    }
    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : window._adftrack ? [window._adftrack] : [];
    window._adftrack.push({
      HttpHost: "track.adform.net",
      pm: ADFORM_ID,
      divider: encodeURIComponent("|"),
      pagename: encodeURIComponent(document.title),
    });
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://s2.adform.net/banners/scripts/st/trackpoint-async.js";
      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    })();
  };


  var initGtag = function () {
    loadYtPreviews();
    if (!GTAG_ID || GTAG_ID === 'XX-XXXXXX') {
      console.log('GTAG_ID: ' + GTAG_ID);
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GTAG_ID);
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + GTAG_ID;
      document.head.append(s);
    })();
  };

  var initFBpx = function() {
    if (!FB_PX || FB_PX === 'XX-XXXXXX') {
      console.log('FB_PX: ' + FB_PX);
      return false;
    }
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', FB_PX);
    fbq('track', 'PageView');
  };

  BPM.COOKIESETTING = JSON.parse(decodeURIComponent(checkCookie("cookieSetting"))) || {
    cookiePolicy: false,
    matomo: false,
    adform: false,
    google: false,
    facebook: false,
  };

  BPM.CookiePolicy = function () {};

  BPM.CookiePolicy.cookieDuration = 30; // Tag/e
  BPM.CookiePolicy.cookieName = "cookieSetting";

  $(function () {
    // console.log(BPM.COOKIESETTING)
    if (!BPM.DNT && BPM.COOKIESETTING.cookiePolicy === false) {
        jQuery("#modal-cookies").modal("show");
    }
    if (BPM.COOKIESETTING.cookiePolicy === true) {
        $("#customCookieModal").prop("checked", true);
        $("#cookieSet1").prop("checked", true);
    }
    if (BPM.COOKIESETTING.matomo === true) {
      $("#customMatomo").prop("checked", true);
      $("#cookieSet3").prop("checked", true);
    }
    if (BPM.COOKIESETTING.adform === true) {
      $("#cookieSet2").prop("checked", true);
      $("#customAdform").prop("checked", true);
      initAdform();
    }
    if (BPM.COOKIESETTING.facebook === true) {
      // $("#cookieSet2").prop("checked", true);
      $("#customFacebook").prop("checked", true);
      initFBpx();
    }
    if (BPM.COOKIESETTING.google === true) {
      $("#customGoogle").prop("checked", true);
      initGtag();

      if (/* BPM.COOKIESETTING.adform && */BPM.COOKIESETTING.facebook === true) {
        $("#cookieSet2").prop("checked", true);
      }
    }
    if (!BPM.DNT) {
      createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    }
  });

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  $(".contact_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");

    var link = $("<a>", {
      href: "mailto:" + mail,
      rel: "nofollow",
      class: ($(el).attr('class') || "").replace('contact_me', ''),
    });
    link.text(mail);
    $(el).replaceWith(link);
  });


  $("html").removeClass("no-js").addClass("js");
  resizeKPIs();

  $(window).resize(
    debounce(function (e) {
      genScrollMenu();
      bpm_fix_menu_md();
      resizeKPIs();
      if ($('.bg-img').length) {
        window.setTimeout(function () {
          $('.bg-img').each(function(index, el) {
            resizeImage($(el));
          });
        }, 0);
      }
    }, 400)
  );


  $(".bpm-carousel-special").each(function (i, el) {
    $(el).find(".carousel .carousel-item:first-of-type").addClass("active");
  });


  function smoothScroll(e, direct) {
    var target;
    if (typeof direct === "undefined" || !direct) {
      target = this.hash || window.location.hash;
      target = !target ? $(e.target).closest("a").attr("href") : target;
    } else {
      target = e;
    }

    var $target = $(target).length ? $(target) : $("[name='" + window.location.hash.substr(1) + "']");

    // console.log($target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - $('.site-header').outerHeight(true),
        },
        400,
        "linear"
        // function() {
        //   window.location.hash = target;
        // }
      );
        if (!!window.history) {
            history.pushState({}, window.title, '#' + $target.attr('id'));
        }
    return false;
  }

    if (!!window.location.hash) {
        smoothScroll(window.location.hash, 1);
    }

    $('.wp-block-bpm-block-btn', '.page-id-269').on('click', function(e) {
        e.preventDefault();
        return smoothScroll("#" + $(e.target).closest('a').attr('href').split("#").pop(), 1);
    });


  // scrollto hash
  $(".scrollTo").on("click", function (e) {
    e.preventDefault();
    smoothScroll(e);
    return false;
  });


  // scrollto navlinks
  $(".nav-link", "#main-primary-menu").on("click", function (e) {
    var href = $(e.target).closest("a").attr("href");
    if (href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
    smoothScroll("#" + href.split("#").pop(), 1);
    $(e.target)
      .closest("ul")
      .find("li.active")
      .removeClass("current-menu-item active current-menu-item current_page_item");
    $(e.target).closest("ul").find("a").removeClass("current-menu-item current_page_item");
    $(e.target)
      .closest("li")
      .addClass("current-menu-item active")
      .find("a")
      .addClass("current-menu-item current_page_item");
    return false;
  });


  // navlink active link onload
  $(window).on("load", function (e) {
    if (window.location.pathname !== "/") return;
    $("#main-primary-menu")
      .find("li.active")
      .removeClass("current-menu-item active current-menu-item current_page_item");
    $("#main-primary-menu").find("a").removeClass("current-menu-item current_page_item");
    $("li:first-of-type", "#main-primary-menu")
      .addClass("current-menu-item active")
      .find("a")
      .addClass("current-menu-item current_page_item");
    return false;
  });


  //--> navlink observer active start page
  var scrollSections = document.querySelectorAll(".section-scroll-to");
  if (!!scrollSections) {
    var options = {
      rootMargin: "-2px",
      threshold: 0.5,
    };

    var callback = function (entries) {
      var items = [];
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          items.push(entry.target.dataset.scrollIndex);
        }
      });
      var max = Math.max.apply(Math, items);
      if (!Number.isFinite(max)) {
        max = 0;
      }
      if (max * 1 >= 0 && items.length) {
        var id = scrollSections[max].getAttribute("id");
        $(".nav-item.active", $scrollMenu).removeClass("active");
        $('.nav-item[href*="#' + id + '"]', $scrollMenu).addClass("active");
      }
    };
    var observer = new IntersectionObserver(callback, options);
    scrollSections.forEach(function (section, index) {
      section.dataset.scrollIndex = index;
      observer.observe(section);
    });
  }

  // nav_scroller sections
  var $scrollMenu;
  function genScrollMenu() {
    if (ww < 1250 && !!document.getElementById("nav_scroller")) {
      document.getElementById("nav_scroller").remove();
    }
    if (ww < 1250 || !document.querySelector(".section-scroll-to") || !!document.getElementById("nav_scroller")) return;
    $scrollMenu = $("<div />", { id: "nav_scroller", class: "nav-scroller" });
    var hashID = window.location.href.split("#").pop();
    $(".section-scroll-to").each(function (index, el) {
      if ($(el).attr("data-scroll-only") === "true") {
      } else {
        var sectionId = $(el).attr("id");
        if (!!sectionId) {
          var $item = $("<a />", {
            class: "nav-item" + (hashID !== sectionId && index !== 0 ? "" : " active"),
            href: "#" + sectionId,
          });
          var $itemText = $("<span />").html($(el).data("title"));
          $item.append($itemText);
          $scrollMenu.append($item);
        }
      }
    });
    $scrollMenu.insertAfter($("#site-footer"));
  }
  genScrollMenu();

  $(document).on("click", function (e) {
    if (!($(e.target).closest(".nav-item").length && $(e.target).closest("#nav_scroller").length)) return;
    $link = $(e.target).closest("a");
    var href = $link.attr("href");
    if (!href || href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
    var hash = "#" + href.split("#").pop();
    smoothScroll(hash, 1);
    $link.closest("#nav_scroller").find(".active").removeClass("active");
    $link.addClass("active");
    if (window.location.hash !== hash) {
      history.pushState({}, window.title, hash);
    }
    return false;
  });
  //<--

  // carousel img repair & touch
  function resizeImage($img) {
    $img.removeClass("resizeVertical");
    if ($img.width() < $img.parent().width() && $img.width() > 0 && $img.height() >= $img.parent().height()) {
      $img.addClass("resizeVertical");
    }
  }

  $('img').on('load', function(e) {
    if ($(e.target).hasClass('bg-img')) {
      resizeImage($(e.target));
    }
  });


  $(".carousel").on("touchstart", function (event) {
    if ($(event.target).closest(".carousel").hasClass("view")) return false;
    var xClick = event.originalEvent.touches[0].pageX;
    $(this).one("touchmove", function (event) {
      var xMove = event.originalEvent.touches[0].pageX;
      if (Math.floor(xClick - xMove) > 5) {
        $(this).carousel("next");
      } else if (Math.floor(xClick - xMove) < -5) {
        $(this).carousel("prev");
      }
    });
    $(".carousel").on("touchend", function () {
      $(this).off("touchmove");
    });
  });

  if (!!navigator.userLanguage || !!navigator.browserLanguage || !!navigator.systemLanguage) {
    $("body").addClass("ie11");
    // console.log("ie11");
  }

  // autoplay yt videos
  $(".modal-yt-video").on("shown.bs.modal", function (e) {
    $("iframe", e.target).attr("src", $("iframe", e.target).attr("data-src") + "?autoplay=1");
  });
  $(".modal-yt-video").on("hidden.bs.modal", function (e) {
    $("iframe", e.target).attr("src", null);
  });

  // yt preview img
  function loadYtPreviews() {
    $('.section-yt-video').each(function(index, el) {
        if ($(el).attr('data-preview') === "true") {
            $(el).find('img').attr(
                'src',
                $(el).find('img').attr('data-src')
            );
        }
    });
  }

  //
  var bpmShadowSvg = function (icon, classes) {
    return '<div class="svg-wrapper"><svg fill="currentColor"'
      + (!classes || classes.length ? '' : (' class="' + classes.join(' ') + '"'))
      + '><use href="#' + icon + '"/></svg></div>';
  };

  
  var $window = $(window);
  function reRenderMainNav() {
      var $oMainNav = $('#navbar-main').find('.container-fluid'),
          $oNavList = $('#main-primary-menu'),
          $oMoreLinks = $oNavList.find('.moreLinks');

      // Abbrechen, wenn Fensterbreite <= 767
      if ($window.width() <= 750) {
          $oMoreLinks.each(function () {
          $(this).addClass('nav-item')
              .find('.dropdown-item')
              .removeClass('dropdown-item')
              .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
          $oMoreLinks.remove();
          return;
      }

      if ($oMoreLinks.length) {
          $oMoreLinks.find('> ul > li').each(function () {
              $(this).addClass('nav-item')
                  .find('> .dropdown-item')
                  .removeClass('dropdown-item')
                  .addClass('nav-link');
          });
          $oMoreLinks.before($oMoreLinks.find('> ul > li'));
      } else {
          var oMoreLinkElem = document.createElement('li'),
              oMoreLinkAElem = document.createElement('a'),
              oMoreLinkUlElem = document.createElement('ul');

          oMoreLinkElem.className = 'dropdown dropstart moreLinks menu-item nav-item';

          oMoreLinkAElem.className = 'dropdown-toggle nav-link menu-item d-inline-flex align-items-center';
          oMoreLinkAElem.innerHTML = '&nbsp;<div class="icon">' + bpmShadowSvg('svg-ellipsis-h') + '</div>&nbsp;'; // BPM.txt.more;
          oMoreLinkAElem.setAttribute('data-bs-toggle', 'dropdown');

          oMoreLinkUlElem.className = 'dropdown-menu';
          oMoreLinkUlElem.setAttribute('role', 'menu');

          oMoreLinkElem.appendChild(oMoreLinkAElem);
          oMoreLinkElem.appendChild(oMoreLinkUlElem);

          $oNavList.append(oMoreLinkElem);
          $oMoreLinks = $(oMoreLinkElem);
      }

      var iMainNavWidth = $oMainNav.width()
              - $oMainNav.find('.navbar-brand').outerWidth(true),
              // - $oMainNav.find('.fixed-header-actions').outerWidth(true),
          $oNavItems = $oNavList.find('> li').not('.moreLinks'),
          iNavItemsWidth = 0,
          aMoreLinkElems = [];

      $oNavItems.each(function () {
          var $this = $( this );
          iNavItemsWidth += $this.outerWidth(true);
      });

      if (iNavItemsWidth > iMainNavWidth) {
          iMainNavWidth -= Math.ceil($oMoreLinks.outerWidth(true));
          iNavItemsWidth = 0;
          
          $oNavItems.each( function ()
              {
                  var $this = $( this );
                  iNavItemsWidth += $this.outerWidth(true);
              
                  if (Math.ceil(iNavItemsWidth) > iMainNavWidth) {
                      $this.removeClass('nav-item')
                          .find('> .nav-link')
                          .addClass('dropdown-item')
                          .removeClass('nav-link');
                      if ($this.hasClass('active')) {
                          $this.find('> a').addClass('active');
                      }
                      aMoreLinkElems.push( $this );
                  }
              }
          );
      }

      if (aMoreLinkElems.length) {
          $oMoreLinks.find('> ul').append(aMoreLinkElems);
      } else {
          $oMoreLinks.remove();
      }
  }

  $(function () {
      reRenderMainNav();
  });
  $(window).resize(function() {
      reRenderMainNav();
  });

    ///////
    ///// === Begin button ripple style === \\\
    $(".ripple").on("click", function(event) {
       var _this = $(this),
           offset = $(this).offset(),
           positionX = (event.pageX - offset.left),
           positionY = (event.pageY - offset.top);
       _this.append("<span class='ripple-effect'>");
       _this.find(".ripple-effect").css({
           left: positionX,
           top: positionY
       }).animate({
           opacity: 0,
       }, 1500, function() {
           $(this).remove();
       });
    });
    // === End button ripple style === \\\
    
    //////

    $('.nav_search').on('click', function(e) {
        if ($(e.target).closest('.search-form').length) return;
        if ($(e.target).closest('.nav_search').hasClass('active')) {
            $(e.target).closest('.nav_search').removeClass('active');
        } else {
            $(e.target).closest('.nav_search').addClass('active');
            $('[name=s]').focus();
        }
    });


    $(document).on('click', function(e) {
        if ($('.nav_search').hasClass('active')
            && !$(e.target).closest('.nav_search').length
        ) {
            $('.nav_search').removeClass('active');
        }
    });

    //////

    var navOffcanvas = document.getElementById('offcanvasMainMenu')
    if (navOffcanvas) {
        navOffcanvas.addEventListener('hide.bs.offcanvas', function () {
            $('#nav_toggler').addClass('text-bg-primary'); 
            $('#nav_toggler .icon-hamburger').addClass('d-block').removeClass('d-none');
            $('#nav_toggler .icon-close').removeClass('d-block').addClass('d-none');
        });
        navOffcanvas.addEventListener('show.bs.offcanvas', function () {
            $('#nav_toggler').removeClass('text-bg-primary');
            $('#nav_toggler .icon-hamburger').removeClass('d-block').addClass('d-none');
            $('#nav_toggler .icon-close').addClass('d-block').removeClass('d-none');
        });

        $('.site-header').on('click', function(e) {
            if ($(e.target).closest('.nav-btns').length
                || $(e.target).closest('a').length
                || $(e.target).closest('.offcanvas-body').length
            ) return;

            if ($('#offcanvasMainMenu').hasClass('show')) {
                var toToggleOffcanvas = bootstrap.Offcanvas.getInstance(navOffcanvas);
                toToggleOffcanvas.hide();
                return false;
            }
        });
    }

    //////

    // navbar dropdown mobile & desktop visible

    $('.nav-item-title').click(function() {
        if (window.innerWidth < 768) {
            $(this).next()
                .slideToggle();
            $(this).toggleClass('active');
        }
        return false;
    });

    function bpm_fix_menu_md() {
        if (window.innerWidth >= 768) {
            $('.nav-item-title').each(function(i, el) {
                $(el).next()
                    .attr('style', '');
                $(el).removeClass('active');
            });
        }
    }

    //////

  // online btn link after check
  $('.sec-teaser-online .btn-circle').on('click', function(e) {
    var $checkbox = $(e.target).closest('.sec').find('[type="checkbox"]');
    $checkbox.removeClass('is-invalid');
    if (!$checkbox.prop('checked')) {
        e.preventDefault();
        $checkbox.addClass('is-invalid');
        return false;
    }
  });

    // tooltip
    var popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    var popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))


    // kpi
    function resizeKPIs() {
        if ($('.sec-kpi-item').length) {
            $('.sec-kpi-item').height(false);
            if ($('.sec-kpi-item').height() < $('.sec-kpi-item').width()) {
                $('.sec-kpi-item').height($('.sec-kpi-item').width());
            }
        }
    }

    // timer
    jQuery('.section-header').each(function(index, el) {
        $('[data-timer]', el).each(function(i, element) {
            // if (i === 0) {
            //     $(element).countdown($(element).data('timer'), function(event) {
            //         $(this).html(event.strftime('%D Tag%!D:e; %H Std %M min'));
            //     });
            // } else {
                $(element).countdown($(element).data('timer'), function(event) {
                    $(this).html(event.strftime('%D Tag%!D:e; %H:%M:%S'));
                });
            // }
        });
    });

    //
    var swiper = new Swiper('.b-actual__slider', {
      slidesPerView: 'auto',
      slidesToScroll: 1,
        freeMode: true,
        navigation: {
            nextEl: ".b-actual__slider .b-swiper-button-next",
            prevEl: ".b-actual__slider .b-swiper-button-prev",
        },
    });


    // tabs
    // scroll
    $('.sec-tabs .nav-link').on('click', function(e) {
        e.preventDefault();
        smoothScroll($(e.target).closest('.nav-link').attr('data-bs-target'), 1);
        return false;
    });

    $('.sec-tabs').each(function(i, el) {
        var hash = location.hash.replace(/^#/, '');
        if (hash) {
            var activeTabEl = el.querySelector('button[data-bs-target="#' + hash + '"]');
        } else {
            var activeTabEl = el.querySelector('button[data-bs-target="#' + el.querySelector('.tab-pane.active').id + '"]');
        }
        var activeTab = new bootstrap.Tab(activeTabEl);
        activeTab.show();
    });

    // Change hash for tab
    var tabEls = document.querySelectorAll('button[data-bs-toggle="tab"]');
    for (var i = 0; i < tabEls.length; i++) {
        tabEls[ i ].addEventListener('shown.bs.tab', function (event) {
            if (!!window.history) {
                history.pushState({}, window.title, event.target.getAttribute('data-bs-target'));
            }
        });
    }


    // forms
    // livestream
    $('form[name="live_stream_login"]').on('submit', function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        data.push({ name: "action", value: "bpmprojectlslogin" });
        data.push({ name: "nonce_in", value: bpm_project_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        data.map(function(x) {
            return (post[x.name] = x.value);
        });

        $.ajax({
            url: bpm_project_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var refresh = false;
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_project_data.errorStandard;
                    }
                    if (!!json.reload) {
                        refresh = true;
                    }

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Livestreamlogin',
                            data.user,
                            0
                        ]);
                    }
                } else {
                    refresh = true;
                    $form[0].reset();
                    messageTxt = json.message || "";

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Livestreamlogin',
                            data.user,
                            1
                        ]);
                    }
                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                if (refresh) {
                    window.setTimeout(function() {
                        window.location.reload();
                    }, 500);
                }

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_project_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    );

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            }
        });

        return false;
    });

    // contact
    $("form[name='contact_form']").on("submit", function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        data.push({ name: "action", value: "bpmprojectformcontact" });
        data.push({ name: "nonce_in", value: bpm_project_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        data.map(function(x) {
            return (post[x.name] = x.value);
        });

        $.ajax({
            url: bpm_project_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_project_data.errorStandard;
                    }

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Kontaktanfrage',
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            0
                        ]);
                    }
                } else {
                    $form[0].reset();
                    $(".form-group-captcha", $form).addClass("d-none");
                    messageTxt = json.message || "";

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Kontaktanfrage',
                            window.location.pathname.split('/').filter(Boolean).shift() || "",
                            1
                        ]);
                    }
                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_project_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    )

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            }
        });

        return false;
    });


    // livestream
    $('form[name="onlineevent_login"]').on('submit', function(e) {
        e.preventDefault();
        var $form = $(e.target);

        var data = $form.serializeArray();
        data.push({ name: "action", value: "bpmprojectoelogin" });
        data.push({ name: "nonce_in", value: bpm_project_data.nonce_in });

        $form.find(".btn[type=submit]").prop("disabled", true);
        $('.loading').prop('hidden', false);
        $('.is-invalid').removeClass('is-invalid');
        $form.find(".alert").attr('hidden', true).removeClass("alert-danger alert-success show");

        var post = {};
        data.map(function(x) {
            return (post[x.name] = x.value);
        });

        $.ajax({
            url: bpm_project_data.ajax_url,
            type: "POST",
            data: post,
            dataType: "json",
            success: function(json, textStatus, XMLHttpRequest) {
                var refresh = false;
                var messageTxt = "";
                if (!json.success) {
                    for (var i = 0; i < json.errors.length; i++) {
                        for (var key in json.errors[i]) {
                            if (key === 'alert') {
                                messageTxt += json.errors[i][ key ] + "\n";
                            } else {
                                $("[name='" + key + "']")
                                    .addClass('is-invalid')
                                    .closest('.mb-3')
                                    .addClass('is-invalid')
                                    .find('.invalid-feedback')
                                    .text(json.errors[i][ key ]);
                            }
                        }
                    }
                    if (messageTxt.trim() == "") {
                        messageTxt = bpm_project_data.errorStandard;
                    }
                    if (!!json.reload) {
                        refresh = true;
                    }

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Onelineeventlogin',
                            'guest',
                            0
                        ]);
                    }
                } else {
                    refresh = true;
                    $form[0].reset();
                    messageTxt = json.message || "";

                    if (typeof _paq !== 'undefined') {
                        _paq.push([
                            'trackEvent',
                            'Onelineeventlogin',
                            'guest',
                            1
                        ]);
                    }
                }

                if (messageTxt.trim() != "") {
                    $form
                        .find(".alert")
                        .attr('hidden', false)
                        .addClass("show alert-" + (!json.success ? "danger" : "success"))
                        .find(".text")
                        .text(messageTxt);
                }

                if (refresh) {
                    window.setTimeout(function() {
                        window.location.reload();
                    }, 500);
                }

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            },
            error: function(MLHttpRequest, textStatus, errorThrown) {
                $form
                    .find(".alert")
                    .attr('hidden', false)
                    .addClass("alert-danger show")
                    .find(".text")
                    .text(
                        MLHttpRequest.status == 403
                        ? bpm_project_data.error403
                        : MLHttpRequest.statusText + " | Errorcode: " + MLHttpRequest.status
                    );

                $form.find(".btn[type=submit]").prop("disabled", false);
                $('.loading').prop('hidden', true);
            }
        });

        return false;
    });


  // tracking
  // accordion
  $(document).on("click", ".sec-accordion .title", function (e) {
    var $title = $(e.target).closest(".title");
    if (typeof _paq !== "undefined") {
      _paq.push([
        "trackEvent",
        "Accordion - " + ($title.attr("aria-expanded") == "true" ? "open" : "close"),
        $title.text(),
      ]);
    }
  });

  // dflip page
  $(document).on("click", ".df-container", function (e) {
    if (typeof _paq !== "undefined") {
      var title = $(e.target).closest(".df-container").attr("data-title");
      var action = "container";

      if ($(e.target).closest(".df-sidemenu").length) {
        action = "chapter - " + $(e.target).closest("a").text();
      } else if ($(e.target).closest(".df-ui-prev").length) {
        action = "prev";
      } else if ($(e.target).closest(".df-ui-next").length) {
        action = "next";
      } else if ($(e.target).closest(".df-ui-zoomin").length) {
        action = "zoomin";
      } else if ($(e.target).closest(".df-ui-zoomout").length) {
        action = "zoomout";
      } else if ($(e.target).closest(".df-ui-fullscreen").length) {
        action = "fullscreen";
      } else if ($(e.target).closest(".df-ui-thumbnail").length) {
        action = "thumbnail";
      } else if ($(e.target).closest(".df-ui-outline").length) {
        action = "menu";
      } else if ($(e.target).closest(".df-ui-page").length) {
        action = "sitenum";
      } else if ($(e.target).closest(".df-ui-download").length) {
        action = "download";
      } else if ($(e.target).closest(".df-ui-pagemode").length) {
        action = "pagemode";
      } else if ($(e.target).closest(".df-ui-start").length) {
        action = "start";
      } else if ($(e.target).closest(".df-ui-end").length) {
        action = "end";
      } else if ($(e.target).closest(".df-ui-sound").length) {
        action = "sound - " + ($(e.target).closest(".df-ui-sound").hasClass("disabled") ? "off" : "on");
      } else if ($(e.target).closest(".df-share-facebook").length) {
        action = "share - facebook";
      } else if ($(e.target).closest(".df-share-twitter").length) {
        action = "share - twitter";
      } else if ($(e.target).closest(".df-share-mail").length) {
        action = "share - mail";
      } else if ($(e.target).closest(".df-ui-share").length) {
        action = "share";
      } else if ($(e.target).closest(".df-ui-more").length) {
        action = "more";
      } else if ($(e.target).closest(".df-ui-controls").length) {
        action = "control";
      }
      var page = $(e.target).closest(".df-container").find(".df-ui-page label").text();
      _paq.push(["trackEvent", "dFlip - " + action, page + " - " + title]);
    }
  });

  // gtag
  function gtag_report_conversion(url) {
    if (typeof dataLayer !== "undefined") {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: GTAG_ID,
        event_callback: callback,
      });
    }
    return false;
  }

  function linkTrackingGTagAdForm() {
    if (BPM.COOKIESETTING.google) {
      gtag_report_conversion();
    }
    if (BPM.COOKIESETTING.adform) {
      window.adf && adf.ClickTrack(this, ADFORM_ID, window.document.title + " Conversion", {});
    }
    if (BPM.COOKIESETTING.adform && !!window.adf) {
      return false;
    }
    return;
  }

  $("#navbar-main .btn-order").on("click", linkTrackingGTagAdForm);


    //// admin bar fix
    if ($('#wpadminbar').length) {
        $('html').attr('style', function(i,s) { return (s || '') + 'margin-top: 0 !important;' });
    }
})(jQuery);
